var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.0 16.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "person_add_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "person_add_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,10 C16.67,10 22,11.34 22,14 L22,16 L6,16 L6,14 C6,11.34 11.33,10 14,10 Z M5,3 L5,6 L8,6 L8,8 L5,8 L5,11 L3,11 L3,8 L0,8 L0,6 L3,6 L3,3 L5,3 Z M14,0 C16.21,0 18,1.79 18,4 C18,6.21 16.21,8 14,8 C11.79,8 10,6.21 10,4 C10,1.79 11.79,0 14,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-129.0 -324.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#person_add_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.99999999999858 320.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#person_add_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22,0 22,16 0,16 0,0",
    stroke: "none"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAdd);
export default __webpack_public_path__ + "static/media/person-add.02ad9c31a6cf3e144421e2572488e640.svg";
export { ForwardRef as ReactComponent };